/**
 * At the Ollie message limit a drafted question can't be sent, so a link
 * that only drafts one ("Ask Ollie about this job") would open Ollie and
 * drop it. A link into a finding's thread stays: Why? / How? there can be
 * free follow-ups (Express decides).
 */

/** Express usage summary (`GET ollie/usage`, or the 402 body) → at the limit. */
export const isOllieUsageAtLimit = usage => usage?.canSend === false

/**
 * `GET ollie/usage` body → at the limit. Express answers 200 with
 * `limitReached` (54.31); older servers sent the 402 body, handled on the
 * error path.
 */
export const isOllieUsageReadAtLimit = data =>
  data?.limitReached === true || isOllieUsageAtLimit(data?.usage)

export const isOllieDraftAskBlocked = ({
  checkId = null,
  atLimit = false,
} = {}) => Boolean(atLimit) && !checkId

/** Re-read usage after this long; one read is shared by every link on the page. */
export const OLLIE_ASK_LIMIT_FRESH_MS = 60 * 1000
